// extracted by mini-css-extract-plugin
var _1 = "styles_container__anhFF";
export { _1 as "container" }
